module.exports = __webpack_public_path__ + "static/media/sign-up-background-hello.135c4e62.png";